import { cn } from "../../../utils/css";
import { Icons } from "../../../icons";
import { SelectOption } from "../constants/signup.types";

interface SelectChipProps {
  option: SelectOption;
  isSelected: boolean;
  onSelect: (option: SelectOption) => void;
  ariaRole: "radio" | "checkbox";
}

const SelectChip = ({
  option,
  isSelected,
  onSelect,
  ariaRole,
}: SelectChipProps) => {
  if (option?.style === "link") {
    return (
      <button
        key={option.id}
        role={ariaRole}
        aria-checked={isSelected}
        onClick={() => onSelect(option)}
        onKeyDown={(e) => {
          if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            onSelect(option);
          }
        }}
        className="tw-mt-3"
      >
        <div className="tw-flex tw-items-center tw-gap-4">
          <span
            className={cn("tw-font-medium tw-text-blue-600")}
            style={{ fontSize: "16px" }}
          >
            {option.label}
          </span>
        </div>
      </button>
    );
  }

  return (
    <button
      key={option.id}
      role={ariaRole}
      aria-checked={isSelected}
      onClick={() => onSelect(option)}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onSelect(option);
        }
      }}
      className={cn(
        "tw-flex tw-w-full tw-gap-3 tw-px-4 tw-h-16 tw-rounded-lg tw-border",
        "tw-justify-between tw-items-center focus:tw-outline-none",
        "tw-transition-all tw-duration-300 tw-ease-in-out",
        isSelected
          ? "tw-bg-blue-50 tw-ring-2 tw-ring-blue-500"
          : "tw-border-gray-300 hover:tw-bg-gray-50 hover:tw-ring hover:tw-ring-ring hover:tw-ring-1",
      )}
    >
      <div className="tw-flex tw-items-center tw-gap-4">
        {option?.icon && (
          <span className="tw-text-3xl" aria-hidden="true">
            {option.icon}
          </span>
        )}
        <span
          className="tw-font-medium tw-text-gray-900"
          style={{ fontSize: "16px" }}
        >
          {option.label}
        </span>
      </div>

      <div
        className={cn(
          "tw-rounded-full tw-p-2 tw-transition-all tw-duration-200",
          isSelected
            ? "tw-bg-blue-500 tw-scale-100 tw-opacity-100"
            : "tw-scale-90 tw-opacity-0",
        )}
      >
        <Icons.Check size={16} color="white" />
      </div>
    </button>
  );
};

export default SelectChip;
